import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminBatchListItem } from "@shared-kernel/application/ports/admin/admin-repository";
import type { BATCH_ORGANIZER_TYPE } from "@academy-context/shared/domain/types/enums/batch-organizer-type";

export const adminRetrieveAllBatches = createAsyncThunk<
  AdminBatchListItem[],
  { organizerType?: BATCH_ORGANIZER_TYPE },
  { extra: Partial<Dependencies> }
>("admin/adminRetrieveAllBatches", async ({ organizerType }, { extra: { adminRepository } }) => {
  return adminRepository!.listAllBatches(organizerType);
});

export const resetAdminRetrieveAllBatches = createAction("admin/resetAdminRetrieveAllBatches");
